import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import RetailContent from './RetailContent';

const styles = theme => ({});

class OtherRetailers extends React.Component {
  render() {
    // eslint-disable-next-line
    const { classes } = this.props;
    return (
      <div>
        <RetailContent id={1} title="manufacturer" markup={2} />
        <RetailContent id={2} title="distributor" markup={3} />
        <RetailContent id={3} title="retailer" markup={4} />
        <RetailContent id={4} title="arrival in your home" markup={null} />
      </div>
    );
  }
}

export default withStyles(styles)(OtherRetailers);
